module.exports = __webpack_public_path__ + "static/img/6.aa6ec1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/6.png
// module id = WpEC
// module chunks = 0